<template>
  <div class="card mt-3">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="card-body">
        <!-- title -->
        <div class="d-md-flex align-items-center">
          <div>
            <h4 class="card-title">Ranking Top 5</h4>
            <h5 class="card-subtitle">{{$t("page.content_dashboard.ranking.sub_title")}}</h5>
          </div>
          <div class="ml-auto">
            <div class="dl">
              <select
                class="custom-select"
                v-on:change="Consultar"
                v-model="filtro_fecha"
              >
                <option value="Mes">{{$t("page.content_dashboard.ranking.mes")}}</option>
                <option value="Dia">{{$t("page.content_dashboard.ranking.dia")}}</option>
                <option value="Semana">{{$t("page.content_dashboard.ranking.semana")}}</option>
                <option value="Anio">{{$t("page.content_dashboard.ranking.ano")}}</option>
              </select>
            </div>
          </div>
        </div>
        <!-- title -->
      </div>
      <div class="table-responsive">
        <table class="table v-middle">
          <thead>
            <tr class="bg-light">
              <th class="border-top-0">{{$t("page.content_dashboard.ranking.posicion")}}</th>
              <th class="border-top-0">{{$t("page.content_dashboard.ranking.insignia")}}</th>
              <th class="border-top-0">{{$t("page.content_dashboard.ranking.nombre_empleado")}}</th>
              <th class="border-top-0">{{$t("page.content_dashboard.ranking.tipo_usuario")}}</th>
              <th class="border-top-0">{{$t("page.content_dashboard.ranking.puesto")}}</th>
              <th class="border-top-0">{{$t("page.content_dashboard.ranking.cursos")}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="empleados.length == 0">
              <td colspan="7" class="text-center pt-3">
                <h5>{{$t("page.content_dashboard.ranking.no_informacion")}}</h5>
              </td>
            </tr>
            <tr v-for="empleado of empleados">
              <td class="text-center">
                <h5>
                  <b>{{ empleado.posicion }}</b>
                </h5>
              </td>
              <td>
                <img
                  v-bind:src="empleado.insignia"
                  style="max-width: 50px; height: auto"
                  alt=""
                />
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <div class="">
                    <h4 class="m-b-0 font-16">
                      {{ empleado.nombre_empleado }}
                    </h4>
                  </div>
                </div>
              </td>
              <td>{{ empleado.tipo_usuario }}</td>
              <td>
                {{ empleado.puesto }}
              </td>
              <td>{{ empleado.total_cursos }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      loading: "",
      result: "d-none",
      empleados: [],
      filtro_fecha: "Anio",
    };
  },
  methods: {
    Consultar() {
      this.Cargando();
      this.$http
        .get("dashboard/ranking/" + this.filtro_fecha)
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.empleados = respuestaJson;
          this.Listo();
        })
        .catch((error) => {
          this.Listo();
        });
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Listo() {
      this.loading = "d-none";
      this.result = "";
    },
  },
  computed: {},
  mounted() {
    this.Consultar();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Ranking/Ranking.vue